import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { DeleteDedicationRequest } from '../api/mytunes/deletededication/deletededicationrequest';
import { DeleteDedicationResponse, DeleteDedicationResponseDtoImpl } from '../api/mytunes/deletededication/deletededicationresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class DeleteDedicationAPIProcessorImpl extends SixdeeCRBTAPIProcessor<DeleteDedicationRequest, DeleteDedicationResponse>
{
    execute(request: DeleteDedicationRequest): void 
    {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try 
        {
            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
             {
                let response = new DeleteDedicationResponseDtoImpl(APIFeatures.DELETE_DEDICATION, "Delete  Success");

                this.getAPISuccess(response);
            }
        }
        catch (e)
        {
            this.getAPIFailure(new DeleteDedicationResponseDtoImpl(APIFeatures.DELETE_FROM_SHUFFLE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
       this.getAPIFailure(new DeleteDedicationResponseDtoImpl(APIFeatures.DELETE_FROM_SHUFFLE, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/deletededicationapiprocessor.tsx